module.exports = __webpack_public_path__ + "phone@2x.png?6caefd2a7584d2f29916069dfe9f24ce";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/phone@2x.png
// module id = 37
// module chunks = 0